import { env } from '@/shared/config';

/**
 * Starts the MSW browser worker when mocking is enabled via `VITE_USE_MOCK`.
 * No-op when disabled, so real API calls pass through untouched.
 */
export async function enableMocking(): Promise<void> {
  if (!env.useMock) return;

  const { worker } = await import('./browser');
  await worker.start({ onUnhandledRequest: 'bypass' });
}
